import { render, staticRenderFns } from "./MonitorViewDialog.vue?vue&type=template&id=0f973cbe"
import script from "./MonitorViewDialog.vue?vue&type=script&lang=js"
export * from "./MonitorViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports